import { createFileRoute } from "@tanstack/react-router";
import { MessagesPage } from "@/features/commcentre/MessagesPage";

export const Route = createFileRoute("/_app/automations/messages/")({
  component: MessagesPage,
});
